export const AuthEndpoints = [
  {
    baseUrl: "seulah",
    name: "customer/user/idNumberValidation",
    alias: "IdNumberValidation",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/user/signin",
    alias: "signin",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/user/otpVerification",
    alias: "otpVerification",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/user/generateOtpForResetPassword",
    alias: "generateOtpForResetPassword",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/user/updateUser",
    alias: "updateUser",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/temp_user/updateUser",
    alias: "tempUserUpdateUser",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/user/deleteUser",
    alias: "deleteUser",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/temp_user/saveDeviceInfo",
    alias: "saveDeviceInfo",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/user/signout",
    alias: "signout",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/user/lean-permissions",
    alias: "leanPermissions",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/application-status/skip",
    alias: "skip",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/sendSoapRequest",
    alias: "sendSoapRequest",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/updateAbsherStatus",
    alias: "updateAbsherStatus",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/user/otpValidationAndResetPassword",
    alias: "otpValidationAndResetPassword",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/user/getApplicationStatus",
    alias: "getApplicationStatus",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  // {
  //   baseUrl: "seulah",
  //   name: "customer/user/otpValidationAndResetPassword",
  //   alias: "otpValidationAndResetPassword",
  //   path: "auth",
  //   noToken: true,
  //   runAt: "onDemand",
  // },
  {
    baseUrl: "seulah",
    name: "customer/settings/public",
    alias: "public",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/user/loan/status",
    alias: "status",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/change-mobile-number/request",
    alias: "request",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/change-mobile-device/request",
    alias: "requestDevice",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/change-mobile-device/resend",
    alias: "resendDevice",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/change-mobile-device/verify",
    alias: "verifyDevice",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/change-mobile-number/resend",
    alias: "resendNumber",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/change-mobile-number/verify",
    alias: "verifyNumber",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/user/acceptTermsAndConditons",
    alias: "acceptTermsAndConditions",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/user/presignedUrl",
    alias: "presignedUrl",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/user/userVerificationByOtp",
    alias: "userVerificationByOtp",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/temp_user/signup",
    alias: "signup",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/user-affiliation/submit",
    alias: "userAffiliation",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/simah/retry",
    alias: "simahRetry",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "hospital",
    name: "hospital-application",
    alias: "hospitalApplication",
    path: "webhooks",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "hospital",
    name: "loan-started",
    alias: "loanStarted",
    path: "webhooks",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "hospital",
    name: "max-loan-offer",
    alias: "maxLoanOffer",
    path: "webhooks",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "hospital",
    name: "difference-approval",
    alias: "differenceApproval",
    path: "webhooks",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "hospital",
    name: "loan-status",
    alias: "loanStatus",
    path: "webhooks",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/checkout-finance/signup",
    alias: "checkoutFinance",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/iban-approve",
    alias: "skipIbanApproval",
    path: "auth",
    noToken: true,
    runAt: "onDemand",
  }
]

export const AuthEndpointsMapping = {
  IdNumberValidation: 'IdNumberValidation',
  Signin: "signin",
  OtpVerification: "otpVerification",
  GenerateOtpForResetPassword: "generateOtpForResetPassword",
  UpdateUser: "updateUser",
  TempUserUpdateUser: "tempUserUpdateUser",
  DeleteUser: "deleteUser",
  SaveDeviceInfo: "saveDeviceInfo",
  Signout: "signout",
  LeanPermissions: "leanPermissions",
  Skip: "skip",
  SendSoapRequest: "sendSoapRequest",
  UpdateAbsherStatus: "updateAbsherStatus",
  OtpValidationAndResetPassword: "otpValidationAndResetPassword",
  GetApplicationStatus: "getApplicationStatus",
  Public: "public",
  Status: "status",
  Request: "request",
  RequestDevice: "requestDevice",
  ResendDevice: "resendDevice",
  VerifyDevice: "verifyDevice",
  ResendNumber: "resendNumber",
  VerifyNumber: "verifyNumber",
  AcceptTermsAndConditions: "acceptTermsAndConditions",
  PresignedUrl: "presignedUrl",
  UserVerificationByOtp: "userVerificationByOtp",
  Signup: "signup",
  UserAffiliation: "userAffiliation",
  SimahRetry: "simahRetry",
  HospitalApplication: "hospitalApplication",
  LoanStarted: "loanStarted",
  MaxLoanOffer: "maxLoanOffer",
  DifferenceApproval: "differenceApproval",
  LoanStatus: "loanStatus",
  CheckoutFinance: "checkoutFinance",
  SkipIbanApproval: "skipIbanApproval"
}